import { useState, useCallback } from 'react';

export const useHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const toggleMenu = useCallback(() => {
    setIsMenuOpen(prev => {
      const newState = !prev;
      
      const navMenu = document.querySelector('._nav-menu');
      if (navMenu) {
        if (newState) {
          navMenu.classList.add('active');
        } else {
          navMenu.classList.remove('active');
        }
      }
      
      const mobileMenu = document.querySelector('._mobile-menu');
      if (mobileMenu) {
        if (newState) {
          mobileMenu.classList.add('active');
        } else {
          mobileMenu.classList.remove('active');
        }
      }
      
      const checkbox = document.querySelector('#open-menu');
      if (checkbox) {
        (checkbox as HTMLInputElement).checked = newState;
      }
      
      return newState;
    });
  }, []);

  const closeMenu = useCallback(() => {
    setIsMenuOpen(false);
    
    const hamburger = document.querySelector('.mobile-hamburger, .menu-icon');
    if (hamburger) {
      hamburger.classList.remove('active');
    }
    
    const navMenu = document.querySelector('._nav-menu');
    if (navMenu) {
      navMenu.classList.remove('active');
    }
    
    const mobileMenu = document.querySelector('._mobile-menu');
    if (mobileMenu) {
      mobileMenu.classList.remove('active');
    }

    const checkbox = document.querySelector('#open-menu');
    if (checkbox) {
      (checkbox as HTMLInputElement).checked = false;
    }
  }, []);

  const handleSearchChange = useCallback((value: string) => {
    setSearchTerm(value);
  }, []);

  const handleSearch = useCallback((term: string) => {
    if (term.trim()) {
      window.location.href = `/resultado-busca?s=${encodeURIComponent(term)}`;
    }
  }, []);

  return {
    isMenuOpen,
    searchTerm,
    toggleMenu,
    closeMenu,
    handleSearchChange,
    handleSearch,
  };
};